module.exports = __webpack_public_path__ + "static/media/Logo.70b7dffd.png";